import api from '../utils/api';

import { logError } from '@zg-rentals/log-error';

const TermsAndConditionsActions = {
  markAcceptedTerms() {
    return (dispatch) => {
      const params = {
        authZone: null,
        userId: null,
        termsAndConditions: [
          {
            type: 'termsAcceptedZillowRentalUser',
            version: 0,
          },
        ],
      };

      return dispatch(api.users.termsAndConditions.markAcceptedTerms(params))
        .then((response) => {
          if (response && response.success === false) {
            return Promise.reject(response.error);
          }

          return response;
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'TermsAndConditionsActions.markAcceptedTerms',
          });
        });
    };
  },
};

export default TermsAndConditionsActions;
